/* Wicket – Commande spéciale : l'atelier (sections/wicket-commande.liquid, bloc « Atelier », snippet wicket-atelier).
   Une feuille 2:3 épinglée ; le défilement fait avancer la personnalisation : la veste se dessine, devient croisée,
   reçoit ses cotes, ses tissus, ses détails ; puis le pantalon se dessine et prend une, puis deux pinces ; enfin les deux
   pièces se posent côte à côte, comme sur une planche de tailleur. Le mouvement suit le défilement avec un léger amorti. Avec
   « réduire les animations », rien n'est épinglé : l'état final s'affiche directement.
   Les boutons « Prendre rendez-vous » de la page font glisser la page jusqu'au formulaire. */
(function(){
  if(window.__wkco) return; window.__wkco = 1;
  var d = document, w = window;
  var rm = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var mqD = w.matchMedia ? w.matchMedia('(min-width: 769px)') : null;
  var N = 8; // étapes

  function each(list, fn){ Array.prototype.forEach.call(list, fn); }
  function clamp(v, a, b){ return v < a ? a : (v > b ? b : v); }
  function ease(t){ t = clamp(t, 0, 1); return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function win(u, a, b){ return ease((u - a) / (b - a)); }
  function lenOf(p){ try { return Math.ceil(p.getTotalLength() + 2); } catch(e) { return 2000; } }
  function fin(g){ var v = ((g && g.getAttribute('data-fin')) || '1,0,0').split(',').map(Number); return v.length === 3 ? v : [1, 0, 0]; }

  // Métamorphose : les deux tracés ont la même structure, seuls les nombres changent.
  var NUM = /-?\d+(?:\.\d+)?/g;
  function Morph(el){
    var a = el.getAttribute('d'), b = el.getAttribute('data-b');
    this.el = el; this.parts = a.split(NUM);
    this.a = (a.match(NUM) || []).map(Number); this.b = (b.match(NUM) || []).map(Number);
    this.ok = this.a.length === this.b.length; this.t = -1;
  }
  Morph.prototype.set = function(t){
    if(!this.ok || t === this.t) return; this.t = t;
    var s = '', i, n = this.a.length;
    for(i = 0; i < n; i++){ s += this.parts[i] + (Math.round((this.a[i] + (this.b[i] - this.a[i]) * t) * 10) / 10); }
    this.el.setAttribute('d', s + this.parts[n]);
  };

  function Atelier(root){
    var self = this;
    var sh = root.querySelector('.wkat-sheet');
    this.root = root;
    this.track = root.querySelector('[data-wkat-track]');
    this.stage = root.querySelector('[data-wkat-stage]');
    this.rot = root.querySelector('.wkat-3d');
    this.caps = root.querySelectorAll('.wkat-cap');
    this.items = root.querySelectorAll('.wkat-steps li, .wkat-dots i');
    this.morphs = []; each(sh.querySelectorAll('[data-b]'), function(p){ self.morphs.push(new Morph(p)); });
    this.draws = []; each(sh.querySelectorAll('[data-dr]'), function(p){ self.draws.push({ el: p, k: +p.getAttribute('data-dr'), len: lenOf(p), v: -1 }); });
    this.pleats = []; each(sh.querySelectorAll('[data-pleat]'), function(p){ self.pleats.push({ el: p, k: +p.getAttribute('data-pleat'), len: lenOf(p), v: -1 }); });
    this.fades = sh.querySelectorAll('[data-fade]');
    this.sb = sh.querySelectorAll('[data-sb]');
    this.db = sh.querySelectorAll('[data-db]');
    this.mv = []; each(sh.querySelectorAll('[data-mv]'), function(g){ var m = g.getAttribute('data-mv').split(','); self.mv.push({ el: g, x: +m[0], y: +m[1] }); });
    this.dims = sh.querySelectorAll('.wkat-dim .l');
    this.fabs = sh.querySelectorAll('[data-fab]');
    this.rings = sh.querySelectorAll('[data-ring]');
    this.plabs = sh.querySelectorAll('[data-plab]');
    this.carts = sh.querySelectorAll('[data-cart]');
    this.jac = sh.querySelector('[data-grp="j"]');
    this.tro = sh.querySelector('[data-grp="t"]');
    this.jf = fin(this.jac); this.tf = fin(this.tro);
    this.ax = sh.querySelector('.wkat-ax');
    this.active = -1; this.cur = 0; this.target = 0; this.running = false; this.span = 0; this.vw = 0; this.vh = 0;
    root.classList.add('wkat--js', 'wkco--js');
    this.choices();
    each(this.draws, function(o){ o.el.style.strokeDasharray = o.len + ' ' + o.len; });
    each(this.pleats, function(o){ o.el.style.strokeDasharray = o.len + ' ' + o.len; });
    if(rm || !this.track || !this.stage){
      root.classList.add('wkat--static');
      this.render(1); this.caption(N - 1, true);
      return;
    }
    root.classList.add('wkat--pin');
    this.size(true);
    this.cur = this.target;
    this.render(this.cur);
    w.addEventListener('scroll', function(){ self.aim(); }, {passive: true});
    w.addEventListener('resize', function(){ self.size(false); });
    w.addEventListener('load', function(){ self.size(true); });
  }

  // Hauteur de la scène : une hauteur d'écran, puis environ six dixièmes d'écran de défilement par étape, et une réserve à la fin.
  Atelier.prototype.size = function(force){
    var vw = w.innerWidth, vh = Math.max(w.innerHeight || 0, d.documentElement.clientHeight || 0);
    if(!force && vw === this.vw && Math.abs(vh - this.vh) < 160){ this.aim(); return; }
    this.vw = vw; this.vh = vh;
    var desk = mqD ? mqD.matches : true;
    // hauteur réelle de l'en-tête, comme pour les blocs épinglés de l'accueil sur téléphone
    var sh = d.getElementById('SiteHeader'), hb = sh ? Math.round(sh.getBoundingClientRect().height) : 0;
    if(hb > 30 && hb < 160) this.root.style.setProperty('--wkat-hh', hb + 'px');
    this.step = Math.round(vh * (desk ? 0.62 : 0.56));
    this.span = this.step * N;
    this.track.style.setProperty('--wkat-track', (vh + this.span + Math.round(this.step * 0.7)) + 'px');
    this.aim();
  };

  // Avancement : de -vh/span (la scène entre par le bas de l'écran) à 0 (elle s'épingle), puis jusqu'à 1 (le costume).
  Atelier.prototype.aim = function(){
    if(!this.span) return;
    var r = this.track.getBoundingClientRect();
    this.target = clamp(-r.top / this.span, -this.vh / this.span, 1);
    if(!this.running){
      var self = this; this.running = true; this.last = 0;
      w.requestAnimationFrame(function(t){ self.tick(t); });
    }
  };

  Atelier.prototype.tick = function(now){
    var self = this;
    var dt = this.last ? Math.min(64, now - this.last) : 16; this.last = now;
    this.cur += (this.target - this.cur) * (1 - Math.exp(-dt / 120));
    if(Math.abs(this.target - this.cur) < 0.0004) this.cur = this.target;
    this.render(this.cur);
    if(this.cur !== this.target) w.requestAnimationFrame(function(t){ self.tick(t); }); else this.running = false;
  };

  Atelier.prototype.render = function(G){
    var P = Math.max(0, G), pre = G < 0 && this.span ? clamp(1 + G * this.span / this.vh, 0, 1) : 1;
    var f = P * N;
    function u(k){ return clamp(f - k, 0, 1); }
    var a0 = win(u(0), 0.04, 0.8), f0 = win(u(0), 0.5, 0.95);
    var a1 = win(u(1), 0.1, 0.8);
    var a2 = win(u(2), 0.08, 0.7), o2 = 1 - win(u(3), 0, 0.22);
    var u3 = u(3), u4 = u(4), u5 = u(5), u6 = u(6), u7 = u(7);
    var fab = [win(u3, 0.06, 0.24) * (1 - win(u3, 0.38, 0.5)), win(u3, 0.38, 0.5) * (1 - win(u3, 0.7, 0.82)), win(u3, 0.7, 0.82) * (1 - win(u4, 0, 0.18))];
    var rOut = 1 - win(u5, 0, 0.22);
    var jx = win(u5, 0, 0.32), tin = win(u5, 0.22, 0.38), a5 = win(u5, 0.24, 0.92), f5 = win(u5, 0.6, 0.98);
    var p1 = win(u6, 0.06, 0.4), p2 = win(u6, 0.5, 0.84);
    var tr = win(u7, 0.04, 0.55), jin = win(u7, 0.35, 0.85), a8 = win(u7, 0.5, 0.95), f8 = win(u7, 0.6, 1);
    // traits qui se dessinent
    each(this.draws, function(o){
      var v = o.k === 0 ? a0 : (o.k === 2 ? a2 : (o.k === 8 ? a8 : a5));
      if(v === o.v) return; o.v = v;
      if(v >= 1){ o.el.style.strokeDasharray = 'none'; o.el.style.strokeDashoffset = 0; }
      else { o.el.style.strokeDasharray = o.len + ' ' + o.len; o.el.style.strokeDashoffset = (o.len * (1 - v)).toFixed(1); }
    });
    each(this.pleats, function(o){
      var v = o.k === 1 ? p1 : p2;
      if(v === o.v) return; o.v = v;
      o.el.style.strokeDashoffset = (o.len * (1 - v)).toFixed(1);
    });
    // veste droite -> croisée
    each(this.morphs, function(m){ m.set(a1); });
    each(this.fades, function(e){
      var k = e.getAttribute('data-fade');
      var v = k === '0' ? f0 : (k === '2' ? a2 * o2 : (k === '8' ? f8 : f5));
      if(e.hasAttribute('data-sb')) v *= 1 - a1;
      e.style.opacity = v.toFixed(3);
    });
    each(this.sb, function(e){ if(!e.hasAttribute('data-fade')) e.style.opacity = (1 - a1).toFixed(3); });
    each(this.db, function(e){ e.style.opacity = (a1 * f0).toFixed(3); e.style.transform = 'scale(' + (0.4 + 0.6 * a1).toFixed(3) + ')'; });
    each(this.mv, function(m){ m.el.style.transform = 'translate(' + (m.x * a1).toFixed(1) + 'px,' + (m.y * a1).toFixed(1) + 'px)'; });
    // cotes : elles s'effacent quand vient le tissu
    each(this.dims, function(e){ e.style.opacity = o2.toFixed(3); });
    // tissus, puis détails
    each(this.fabs, function(e){ e.style.opacity = (fab[+e.getAttribute('data-fab') - 1] * 0.95).toFixed(3); });
    each(this.rings, function(e){
      var j = +e.getAttribute('data-ring'), v = win(u4, 0.08 + j * 0.2, 0.3 + j * 0.2) * rOut;
      e.style.opacity = v.toFixed(3); e.style.transform = 'scale(' + (0.6 + 0.4 * v).toFixed(3) + ')';
    });
    // la veste laisse place au pantalon, puis revient à sa gauche : la planche du tailleur (positions finales calculées par le générateur : data-fin)
    // (le pantalon glisse d'abord à droite, puis la veste apparaît à gauche, à sa place, sans croiser le pantalon)
    var J = this.jf, T = this.tf, jo, js, jex, jey;
    if(f < 7){ jo = 1 - jx; js = 1; jex = 0; jey = -30 * jx; }
    else { jo = jin; js = J[0]; jex = J[1] - 46 * (1 - jin); jey = J[2]; }
    this.jac.style.opacity = jo.toFixed(3);
    this.jac.setAttribute('transform', 'matrix(' + js.toFixed(4) + ' 0 0 ' + js.toFixed(4) + ' ' + jex.toFixed(1) + ' ' + jey.toFixed(1) + ')');
    if(this.ax) this.ax.style.opacity = (f0 * (1 - jx)).toFixed(3);
    var ts = 1 + (T[0] - 1) * tr, tex = T[1] * tr, tey = T[2] * tr;
    this.tro.style.opacity = tin.toFixed(3);
    this.tro.setAttribute('transform', 'matrix(' + ts.toFixed(4) + ' 0 0 ' + ts.toFixed(4) + ' ' + tex.toFixed(1) + ' ' + tey.toFixed(1) + ')');
    var pl = [tin * (1 - win(u6, 0.1, 0.3)), win(u6, 0.1, 0.3) * (1 - win(u6, 0.5, 0.7)), win(u6, 0.5, 0.7) * (1 - win(u7, 0, 0.2))];
    each(this.plabs, function(e){ e.style.opacity = pl[+e.getAttribute('data-plab')].toFixed(3); });
    var ca = [1 - win(u5, 0.2, 0.4), win(u5, 0.2, 0.4) * (1 - win(u7, 0, 0.2)), win(u7, 0, 0.2)];
    each(this.carts, function(e){ e.style.opacity = ca[+e.getAttribute('data-cart')].toFixed(3); });
    // la feuille se redresse en arrivant, puis tourne doucement dans l'espace ; un reflet glisse sur le papier
    if(this.rot && !this.root.classList.contains('wkat--static')){
      var e = 1 - ease(pre), ry = -7 + 14 * P;
      this.rot.style.setProperty('--ry', ry.toFixed(2) + 'deg');
      this.rot.style.setProperty('--rx', (6 - 4 * P + 30 * e).toFixed(2) + 'deg');
      this.rot.style.setProperty('--tz', (-160 * e).toFixed(1) + 'px');
      this.rot.style.setProperty('--sh', (0.5 + ry / 28 - 0.35 * e).toFixed(3));
    }
    // légende de l'étape
    this.caption(Math.min(N - 1, Math.floor(f + 0.06)));
    each(this.items, function(e, j){ e.style.setProperty('--p', u(j % N).toFixed(3)); });
  };

  Atelier.prototype.caption = function(k, all){
    if(k === this.active && !all) return;
    this.active = k;
    each(this.caps, function(c, j){ c.classList.toggle('is-on', all ? true : j === k); });
    each(this.items, function(e, j){ var i = j % N; e.classList.toggle('is-on', i === k); e.classList.toggle('is-done', i < k); });
  };

  // Les quatre choix : les filets se tracent à l'apparition.
  Atelier.prototype.choices = function(){
    var list = this.root.querySelector('[data-wkco-list]');
    if(!list) return;
    if(rm || !('IntersectionObserver' in w)){ list.classList.add('is-in'); return; }
    var o = new IntersectionObserver(function(en){
      en.forEach(function(x){ if(x.isIntersecting){ list.classList.add('is-in'); o.disconnect(); } });
    }, {rootMargin: '0px 0px -10% 0px', threshold: 0.1});
    o.observe(list);
  };

  // « Prendre rendez-vous » : la page glisse jusqu'au formulaire (l'ancre garde sa marge sous l'en-tête).
  function glide(e){
    var id = (e.currentTarget.getAttribute('href') || '').slice(1), t = id && d.getElementById(id);
    if(!t) return;
    e.preventDefault();
    function goal(){ return Math.max(0, t.getBoundingClientRect().top + (w.pageYOffset || 0) - (parseFloat(w.getComputedStyle(t).scrollMarginTop) || 0)); }
    function go(y){ try { w.scrollTo({top: y, left: 0, behavior: 'instant'}); } catch(x) { w.scrollTo(0, y); } }
    if(rm){ go(goal()); return; }
    var y0 = w.pageYOffset || 0, dur = Math.min(2400, 800 + Math.abs(goal() - y0) * 0.16), t0 = 0, stop = false;
    function halt(){ stop = true; }
    w.addEventListener('wheel', halt, {passive: true, once: true});
    w.addEventListener('touchstart', halt, {passive: true, once: true});
    function step(now){
      if(stop) return;
      if(!t0) t0 = now;
      var k = Math.min(1, (now - t0) / dur);
      go(y0 + (goal() - y0) * ease(k));
      if(k < 1) w.requestAnimationFrame(step);
      else { w.removeEventListener('wheel', halt); w.removeEventListener('touchstart', halt); }
    }
    w.requestAnimationFrame(step);
  }

  function all(){
    each(d.querySelectorAll('.wkhm--page a.wkhm-co-cta[href^="#"]'), function(a){
      if(a.__wkg) return; a.__wkg = 1; a.addEventListener('click', glide);
    });
    each(d.querySelectorAll('[data-wkat]'), function(r){
      if(r.__wkat) return;
      try { r.__wkat = new Atelier(r); } catch(e) {
        r.__wkat = 1;
        r.classList.remove('wkat--pin'); r.classList.add('wkat--static', 'wkat--nojs');
        var l = r.querySelector('[data-wkco-list]'); if(l) l.classList.add('is-in');
      }
    });
  }
  if(d.readyState === 'loading') d.addEventListener('DOMContentLoaded', all); else all();
  d.addEventListener('shopify:section:load', all);
})();
